// HeroLocalListing.jsx
// Same structure/design as your demo — only content updated for "Local Listing"

import React from "react";
// import heroLeaves from "../assets/hero-leaves.png"; // optional (same as your old)
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
export default function Hero() {
  return (
    <section className="relative pt-8 w-full overflow-hidden a">
      {/* soft vignette */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/35 via-transparent to-white/10" />

      <div className="relative mx-auto w-[90%] 2xl:w-[70%] py-12 lg:py-16">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          {/* LEFT */}
          <div className="lg:col-span-7">
            <h1 className="mt-4  h1-mb h1-md h1-lg h1-2xl">
                                        Local Listing - Für {" "}
                                        <span className="relative inline-block md:mt-4 md:mb-2">
                                            <span className="relative inline-block">
                                                <span className="easiest-badge !text-[#0b2b40]">
                                                    Mehr
                                                </span>

                                                {/* small accent lines */}
                                                <span className="absolute -top-2 -right-2 h-2 w-2 rotate-12 rounded-full bg-lime-300" />
                                                <span className="absolute -top-3 right-3 h-3 w-[2px] rotate-12 bg-lime-300" />
                                            </span>

                                        </span>{" "}
                                        Sichtbarkeit
                                    </h1>

            <p className="mt-6 md:text-xl leading-6 text-[#163949]/70">
              Ob Google, Apple Maps, Bing, Yelp oder Gelbe Seiten: Wir sorgen
              dafür, dass Ihre Unternehmensdaten auf allen bekannten Plattformen
              einheitlich dargestellt werden.
            </p>

            {/* Bottom-left analytics card (keep same design / numbers as demo) */}
            <div className="mt-12 w-full max-w-[560px] rounded-2xl bg-white/85 p-5 shadow-[0_18px_50px_rgba(8,40,30,0.18)] ring-1 ring-black/5 backdrop-blur">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="grid h-9 w-9 place-items-center rounded-full bg-[#EEF6D6] ring-1 ring-black/5">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-[#163949]"
                    >
                      <path
                        d="M13 2L3 14h7l-1 8 10-12h-7l1-8Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="text-sm font-semibold text-[#0F2C3D]">
                    Sichtbarkeit (Demo)
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    className="grid h-9 w-9 place-items-center rounded-full bg-white ring-1 ring-black/5 hover:bg-[#F5F8EE]"
                    aria-label="Edit"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-[#163949]"
                    >
                      <path
                        d="M12 20h9"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />
                      <path
                        d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4 11.5-11.5Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  <div className="h-9 w-9 rounded-full bg-[#9BC23A]/90 ring-2 ring-white" />
                </div>
              </div>

              <div className="mt-5 flex items-end justify-between gap-6">
                <div className="text-[44px] font-semibold tracking-tight text-[#0F2C3D]">
                  + 370%
                </div>
                <div className="pb-2 text-lg font-semibold text-[#0F2C3D]">
                  60+ Plattformen
                </div>
              </div>

              {/* bars */}
              <div className="mt-5 grid grid-cols-5 gap-4">
                <Bar value={36} />
                <Bar value={44} striped />
                <Bar value={74} striped />
                <Bar value={40} />
                <Bar value={52} />
              </div>

              <div className="mt-3 flex justify-between px-1 text-xs font-medium text-[#163949]/55">
                <span>Live</span>
                <span>Sync</span>
                <span>Check</span>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
                                        <Link
                                            to="/kontak"
                                            className="group inline-flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-black shadow transition hover:bg-white/90"
                                        >
                                            Kontakt
                                            <ArrowRight size={16} className="transition group-hover:translate-x-0.5" />
                                        </Link>

                                        <Link
                                            to="/unverbindliches-angebot"
                                            className="inline-flex items-center rounded-xl border border-white/55 bg-[#0b2b40] px-5 py-2.5 text-sm font-semibold text-white/85 transition hover:bg-[#0b2b40]/90"
                                        >
                                            Angebot einholen
                                        </Link>
                                    </div>
          </div>

          {/* RIGHT */}
          <div className="relative lg:col-span-5">
            {/* leaves background image (optional) */}
            <img
              src=""
              alt=""
              className="pointer-events-none absolute -right-10 top-[-40px] w-[520px] max-w-none select-none opacity-95 lg:w-[640px]"
            />

            {/* right stack */}
            <div className="relative ml-auto flex max-w-[360px] flex-col gap-5">
              {/* Card 1 */}
              <div className="rounded-2xl bg-white/92 p-5 shadow-[0_18px_50px_rgba(8,40,30,0.18)] ring-1 ring-black/5 backdrop-blur">
                <div className="flex items-start justify-between">
                  <div className="text-lg font-semibold text-[#0F2C3D]">
                    Plattform-Reichweite
                  </div>
                  <button
                    type="button"
                    className="grid h-8 w-8 place-items-center rounded-full hover:bg-black/5"
                    aria-label="More"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-[#163949]/70"
                    >
                      <path
                        d="M5 12h.01M12 12h.01M19 12h.01"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  <Pill active>Maps</Pill>
                  <Pill>Search</Pill>
                  <Pill>Portale</Pill>
                  <Pill>SEO</Pill>
                </div>

                <div className="mt-4 flex items-center justify-between">
                  <div className="text-3xl font-semibold tracking-tight text-[#0F2C3D]">
                    60+
                  </div>
                  <div className="rounded-full bg-[#E7F3C4] px-3 py-1 text-sm font-semibold text-[#4C6A14] ring-1 ring-black/5">
                    + schnell
                  </div>
                </div>

                <div className="mt-4 h-3 w-full rounded-full bg-[#EAF4CC] ring-1 ring-black/5">
                  <div className="h-3 w-[72%] rounded-full bg-[#9BC23A]" />
                </div>

                <div className="mt-3 flex items-center justify-between text-sm font-medium text-[#163949]/70">
                  <span>Einheitliche Daten</span>
                  <span className="text-[#4C6A14]">Sync aktiv</span>
                </div>
              </div>

              {/* Card 2 */}
              <div className="relative rounded-2xl bg-white/92 p-5 shadow-[0_18px_50px_rgba(8,40,30,0.18)] ring-1 ring-black/5 backdrop-blur">
                <div className="flex items-start justify-between">
                  <div className="grid h-11 w-11 place-items-center rounded-full bg-[#0F2C3D] text-white ring-1 ring-black/10">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="text-white"
                    >
                      <path
                        d="M7 17L17 7"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M9 7h8v8"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>

                  <div className="text-2xl font-semibold text-[#4C6A14]">
                    + Sichtbarkeit
                  </div>
                </div>

                <p className="mt-4 text-sm leading-6 text-[#163949]/70">
                  Stärkere lokale Sichtbarkeit in
                  <br />
                  Karten- und Suchdiensten –
                  <br />
                  mehr Anfragen von Neukunden.
                </p>

                <button
                  type="button"
                  className="mt-5 inline-flex items-center justify-center rounded-full bg-[#D9EA9A] px-6 py-3 text-sm font-semibold text-[#0F2C3D] shadow-sm ring-1 ring-black/5 hover:bg-[#D1E686]"
                >
                  Learn More
                </button>

                {/* tiny dots at right like reference */}
                <div className="pointer-events-none absolute right-6 top-1/2 hidden -translate-y-1/2 flex-col gap-2 lg:flex">
                  {[...Array(4)].map((_, i) => (
                    <span
                      key={i}
                      className="h-2 w-2 rounded-full bg-[#CFE37F] opacity-70"
                    />
                  ))}
                </div>
              </div>

              {/* Card 3 */}
              <div className="rounded-2xl bg-white/92 p-6 shadow-[0_18px_50px_rgba(8,40,30,0.18)] ring-1 ring-black/5 backdrop-blur">
                <div className="text-2xl font-semibold leading-tight text-[#0F2C3D]">
                  Vorteile auf
                  <br />
                  einen Blick
                </div>

                <div className="mt-5 flex flex-wrap gap-3">
                  <Tag>Google & Co</Tag>
                  <Tag>Maps</Tag>
                  <Tag>Neukunden</Tag>
                  <Tag>SEO</Tag>
                  <Tag>Portale</Tag>
                  <Tag>Bewertungen</Tag>
                </div>
              </div>
            </div>

            {/* Center CTA + copy (was empty in your demo; keeping it empty so design stays same) */}
          </div>
        </div>

        {/* Optional: your bullet list (kept outside cards so layout stays identical) */}
        
      </div>
    </section>
  );
}

function Pill({ children, active = false }) {
  return (
    <span
      className={[
        "rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-black/5",
        active
          ? "bg-[#D9EA9A] text-[#0F2C3D]"
          : "bg-[#F2F6E3] text-[#163949]/70",
      ].join(" ")}
    >
      {children}
    </span>
  );
}

function Tag({ children }) {
  return (
    <span className="rounded-full bg-[#F2F6E3] px-4 py-2 text-sm font-semibold text-[#0F2C3D] ring-1 ring-black/5">
      {children}
    </span>
  );
}

function Bar({ value = 50, striped = false }) {
  return (
    <div className="h-[72px] w-[60px] rounded-2xl bg-[#F1F6DF] p-2 ring-1 ring-black/5">
      <div
        className={[
          "h-full w-full rounded-xl bg-[#9BC23A]",
          striped
            ? "bg-[linear-gradient(135deg,rgba(255,255,255,0.22)_0%,rgba(255,255,255,0.22)_25%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_50%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.22)_75%,rgba(255,255,255,0)_75%,rgba(255,255,255,0)_100%),linear-gradient(#9BC23A,#9BC23A)] bg-[length:14px_14px,auto]"
            : "",
        ].join(" ")}
        style={{
          transform: `scaleY(${Math.max(0.18, value / 100)})`,
          transformOrigin: "bottom",
        }}
      />
    </div>
  );
}
